var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar"},[_c('vue-calendar',{attrs:{"show-limit":20,"events":_vm.events},on:{"event-clicked":_vm.handleCalendarEventClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }